import { INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH } from '@/components/MediaKit/FavouriteFacts/favouriteFactsDisplay';

/** Safe parse for paidPost / freePost JSON blobs. */
export const parseTopPostBlob = jsonStr => {
  if (jsonStr == null || jsonStr === '') return {};
  if (typeof jsonStr === 'object') return jsonStr;
  try {
    return JSON.parse(jsonStr);
  } catch {
    return {};
  }
};

/**
 * Parse each row, sort by postIndex, return carousel rows (all but last two slots).
 */
export const buildTopPostCarouselRows = rawTopPosts => {
  if (!Array.isArray(rawTopPosts) || rawTopPosts.length === 0) return [];
  const rows = rawTopPosts.map(post => ({
    ...post,
    paidPost: parseTopPostBlob(post?.paidPost),
    freePost: parseTopPostBlob(post?.freePost)
  }));
  return rows.sort((a, b) => (a?.postIndex ?? 0) - (b?.postIndex ?? 0)).slice(0, -2);
};

/**
 * Normalize post link for window.open. Returns null if unusable.
 */
export const normalizeOutboundPostLink = link => {
  if (link == null || link === '') return null;
  const s = String(link).trim();
  if (!s) return null;
  if (/^https?:\/\//i.test(s)) return s;
  try {
    const withProto = s.includes('://') ? `https://${s.split('://').pop()}` : `https://${s}`;
    // eslint-disable-next-line no-new
    new URL(withProto);
    return withProto;
  } catch {
    return null;
  }
};

/** Stat labels in top-post UI that align with favourite-facts shield list (subset with toggles). */
const IG_STAT_LABEL_TO_TOGGLE_KEY = {
  'Engagement Rate': 'engagementRateToggle',
  Views: 'viewsToggle'
};

/** True if this stat row should show shield when Instagram is not authenticated. */
export const shouldShieldInstagramTopPostStat = ({
  postWithType,
  statLabel,
  isInstagramAuthenticated
}) => {
  if (isInstagramAuthenticated) return false;
  if (postWithType?.socialChannel?.toLowerCase() !== 'instagram') return false;
  if (!INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH.includes(statLabel)) return false;
  const toggleKey = IG_STAT_LABEL_TO_TOGGLE_KEY[statLabel];
  if (!toggleKey) return false;
  return Boolean(postWithType?.statsDisplay && postWithType?.[toggleKey]);
};

/**
 * For validators: Instagram post with stats on needs auth if any shielded metric toggle is on.
 */
export const instagramTopPostNeedsAuthForStats = post => {
  if (!post || post?.socialChannel?.toLowerCase() !== 'instagram') return false;
  if (!post.statsDisplay) return false;
  return INSTAGRAM_FACTS_SHIELDED_WHEN_UNAUTH.some(label => {
    const key = IG_STAT_LABEL_TO_TOGGLE_KEY[label];
    return key ? Boolean(post[key]) : false;
  });
};

/** Stable key for Swiper / lists */
export const getTopPostRowKey = (post, index) =>
  post?.id != null ? `top-post-${post.id}` : `top-post-idx-${post?.postIndex ?? index}`;
